import React from 'react';
import Slider from '../components/Slider';

const EXERCISE_OPTIONS = ['Pilates', 'Walking', 'Yoga', 'Rest Day'];

export default function LifestyleStep({ data, update, checkInType }) {
  const selectExercise = (label) => {
    update({ exerciseType: data.exerciseType === label ? null : label });
  };

  return (
    <div className="space-y-6">
      {/* Sleep — show for morning check-in */}
      {checkInType === 'MORNING' && (
        <>
          <Slider
            label="Sleep Quality (last night)"
            value={data.sleepQuality}
            onChange={(v) => update({ sleepQuality: v })}
            lowLabel="Terrible"
            highLabel="Amazing"
          />

          <div>
            <label className="block text-sm font-medium text-white/80 mb-1">Hours of Sleep</label>
            <input
              type="number"
              min="0"
              max="24"
              step="0.5"
              value={data.sleepHours || ''}
              onChange={(e) => update({ sleepHours: e.target.value ? parseFloat(e.target.value) : null })}
              placeholder="e.g. 7.5"
              className="w-full rounded-lg bg-white/10 border-white/20 text-white placeholder-white/40 shadow-sm focus:border-white/40 focus:ring-white/30"
            />
          </div>
        </>
      )}

      <Slider
        label="Stress Level"
        value={data.stressLevel}
        onChange={(v) => update({ stressLevel: v })}
        lowLabel="Calm"
        highLabel="Very stressed"
      />

      {/* Exercise section */}
      <div className="border-t border-white/10 pt-4">
        <p className="text-sm font-medium text-white/80 mb-3">Exercise / Movement</p>
        <div className="flex flex-wrap gap-2 mb-3">
          {EXERCISE_OPTIONS.map((label) => {
            const selected = data.exerciseType === label;
            return (
              <button
                key={label}
                type="button"
                onClick={() => selectExercise(label)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition
                  ${selected
                    ? 'bg-white/20 text-white ring-2 ring-white/30'
                    : 'bg-white/10 text-white/60 hover:bg-white/20'
                  }`}
              >
                {label}
              </button>
            );
          })}
          <button
            type="button"
            onClick={() => selectExercise('Other')}
            className={`px-4 py-2 rounded-full text-sm font-medium transition
              ${data.exerciseType === 'Other'
                ? 'bg-white/20 text-white ring-2 ring-white/30'
                : 'bg-white/10 text-white/60 hover:bg-white/20'
              }`}
          >
            Other
          </button>
        </div>

        {data.exerciseType === 'Other' && (
          <input
            type="text"
            value={data.exerciseNotes || ''}
            onChange={(e) => update({ exerciseNotes: e.target.value })}
            placeholder="What did you do? (e.g., swimming, cycling, stretching)"
            className="w-full rounded-lg bg-white/10 border-white/20 text-white placeholder-white/40 shadow-sm focus:border-white/40 focus:ring-white/30"
          />
        )}
      </div>

      {/* Recovery section */}
      <div className="border-t border-white/10 pt-4">
        <p className="text-sm font-medium text-white/80 mb-3">Recovery</p>

        <Slider
          label="Surgery Recovery Pain"
          value={data.recoveryPainLevel}
          onChange={(v) => update({ recoveryPainLevel: v })}
          lowLabel="None"
          highLabel="Severe"
        />
      </div>
    </div>
  );
}
